module.exports = {
  type: 'stl',
  id: 'part',
  icon: 'table',
  title: 'ProjectDetails.stlUpload',
  intro: {
    de: 'Dieser Reiter dient ausschließlich zum Upload der STL-Datei des fertigen Restaurationsdesigns. Um Scans und Anhänge kümmern wir uns gleich!',
    en: ''
  },
  requires: 1,
};
